import React from 'react'

import { EmojiList } from 'components/EmojiPicker/EmojiList'
import MCEditorContext from 'components/MCTextEditor/MCEditorContext'

import { IToolPopover } from '../toolbarInterfaces'

const Emojis: IToolPopover = ({ onSelect = () => undefined }) => {
  const editorContext = React.useContext(MCEditorContext)

  const handleSelect: (value: { native: string }) => void = ({ native: char }) =>
    void onSelect(char)

  return (
    <EmojiList
      onSelect={handleSelect}
      includeInstagramCategory={editorContext?.toolbar?.includeInstagramCategoryToEmojiPicker}
    />
  )
}

export default Emojis
